/* eslint-disable no-restricted-syntax */
import React, { useState, useEffect, useMemo } from 'react';
import { Checkbox, Grid, TextField, Typography, makeStyles, FormControlLabel } from '@material-ui/core';
import { ChevronRight } from '@material-ui/icons';
import _isEmpty from 'lodash/isEmpty';
import { ErrorToast, searchArray } from '../utils/Utils';
import ZeroState from '../common/ZeroState';
import CarIcon from '../../assets/CarIcon';

const useStyles = makeStyles(() => ({
  mainDivForStep2: {
    backgroundColor: 'white',
    maxHeight: '45%',
    height: '45%',

    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  searchText: {
    width: '98%',
    height: '42px',
    background: '#FAFAFA',
    border: '1px solid #E2E2E2',
    padding: '8px',
    fontFamily: 'Montserrat',
    fontWeight: '500',
    fontSize: '14px',
    borderRadius: '8px',
    margin: '10px',
  },
  scrollableGrid: {
    // height: '280px',
    // maxHeight: '280px',
    overflowY: 'auto',
    overflowX: 'hidden',
    '&::-webkit-scrollbar': { width: '10px' },
    '&::-webkit-scrollbar-track': {
      boxShadow: 'inset 0 0 5px grey',
      borderRadius: '20px',
    },
    '&::-webkit-scrollbar-thumb': {
      background: 'lightGrey',
      borderRadius: '100px',
    },
  },
  searchDealershipContainer: {
    display: 'flex',
    alignItems: 'center',
    alignSelf: 'stretch',
    justifyContent: 'flex-start',
    borderRadius: '8px',
    border: '1px solid var(--brand-200, #D9D6FE)',
    background: 'var(--brand-50, #FFFFFF)',
    height: '11%',
    marginBottom: '10px',
  },
  gridContainerStyle: {
    backgroundColor: '#FFFFFF',
    borderRadius: '8px',
    marginLeft: '10px',
    overflowY: 'auto',
  },
  centerBoxElement: {
    borderLeft: '2px solid #D9D6FE',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '35vh',
  },
  checkBoxWrapper: {
    background: 'lightGrey',
    width: '100%',
    marginLeft: '0px',
  },
  selectAllCheckbox: {
    borderRadius: '8px',
    borderColor: '#D0D5DD',
    marginLeft: '10px',
  },
  filedName: {
    fontWeight: '600',
    fontSize: '14px',
    cursor: 'pointer',
    width: '100%',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  countBox: {
    padding: '5px',
    borderRadius: '10px',
    backgroundColor: '#D9D6FE',
    fontSize: '10px !important',
  },
}));

export default function DealershipList({
  dealershipListForTopic,
  selectedList,
  setSelectedList,
  onApplyAllDepartment,
}) {
  const classes = useStyles();
  const [searchDealershipValue, setSearchDealershipValue] = useState('');
  const [filteredDealerships, setFilteredDealerships] = useState([]);
  const [childrenViewList, setChildrenViewList] = useState({
    dealershipId: {},
    departmentId: {},
  });

  React.useEffect(() => {
    window.applyDepartmentToAllDealerships = () => {
      const currentDepartment = childrenViewList.departmentId;
      const currentDealershipId = childrenViewList.dealershipId?.id;

      if (onApplyAllDepartment && currentDepartment?.id && currentDealershipId) {
        onApplyAllDepartment(currentDepartment, currentDealershipId);
      } else {
        ErrorToast('Please select a dealership and department first');
      }
    };
  }, [childrenViewList, onApplyAllDepartment]);

  useEffect(() => {
    setFilteredDealerships(dealershipListForTopic);
  }, [dealershipListForTopic]);

  const handleDealershipSearch = (e) => {
    const input = e.target.value;
    setSearchDealershipValue(input);

    // Filter the dealerships based on the search input
    const filtered = searchArray(dealershipListForTopic || [], ['name'], input);
    setFilteredDealerships(filtered);
  };

  const checkRole = (role) => {
    const checkR =
      !_isEmpty(selectedList[childrenViewList.dealershipId.id]) &&
      !_isEmpty(selectedList[childrenViewList.dealershipId.id][childrenViewList.departmentId.id]) &&
      selectedList[childrenViewList.dealershipId.id][childrenViewList.departmentId.id].includes(role.id);
    return checkR;
  };

  const onChangeDealer = (dealerId, isChecked, isIndeterminate) => {
    const temp = { ...selectedList };
    if (isChecked && !isIndeterminate) {
      const tempDept = {};
      dealerId.departments.forEach((i) => {
        const enabledRoles = i.roles.filter((role) => !role.disabled).map((role) => role.id);
        if (enabledRoles.length > 0) {
          tempDept[i.id] = enabledRoles;
        }
      });
      temp[dealerId.id] = { ...tempDept };
    } else {
      delete temp[dealerId.id];
    }
    setSelectedList(temp);
  };

  const onChangeDepartment = (departmentId, isChecked, isIndeterminate) => {
    const temp = { ...selectedList };

    if (isChecked && !isIndeterminate) {
      if (_isEmpty(temp[childrenViewList.dealershipId.id])) {
        temp[childrenViewList.dealershipId.id] = {};
      }

      // Filter out disabled roles before adding their IDs to temp
      const enabledRoleIds = departmentId.roles.filter((role) => !role.disabled).map((role) => role.id);
      temp[childrenViewList.dealershipId.id][departmentId.id] = enabledRoleIds;
    } else {
      delete temp[childrenViewList.dealershipId.id][departmentId.id];

      if (Object.keys(temp[childrenViewList.dealershipId.id]).length === 0) {
        delete temp[childrenViewList.dealershipId.id];
      }
    }
    setSelectedList(temp);
  };

  const onChangeRole = (roleId, isChecked) => {
    const temp = { ...selectedList };

    if (isChecked) {
      if (!_isEmpty(temp[childrenViewList.dealershipId.id])) {
        if (!_isEmpty(temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id])) {
          temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id].push(roleId.id);
        } else {
          temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id] = [roleId.id];
        }
      } else {
        temp[childrenViewList.dealershipId.id] = {
          [childrenViewList.departmentId.id]: [roleId.id],
        };
      }
    } else {
      if (
        !_isEmpty(temp[childrenViewList.dealershipId.id]) &&
        !_isEmpty(temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id])
      ) {
        const index = temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id].indexOf(roleId.id);
        if (index > -1) {
          temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id].splice(index, 1);
        }

        if (temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id].length === 0) {
          delete temp[childrenViewList.dealershipId.id][childrenViewList.departmentId.id];
        }
      }

      if (_isEmpty(temp[childrenViewList.dealershipId.id])) {
        delete temp[childrenViewList.dealershipId.id];
      }
    }
    setSelectedList(temp);
  };

  const onSelectAllDealerships = () => {
    const temp = { ...selectedList };
    if (isAllDealershipsChecked()) {
      filteredDealerships.forEach((dealer) => {
        delete temp[dealer.id];
      });
    } else {
      filteredDealerships.forEach((dealer) => {
        if (!dealer.disabled) {
          temp[dealer.id] = {};

          dealer.departments.forEach((department) => {
            if (!department.disabled) {
              // Filter out disabled roles before adding their IDs to temp
              const enabledRoleIds = department.roles.filter((role) => !role.disabled).map((role) => role.id);
              temp[dealer.id][department.id] = enabledRoleIds;
            }
          });
        }
      });
    }
    setSelectedList(temp);
  };

  const onSelectAllDepartments = () => {
    const temp = { ...selectedList };

    if (!isAllDepartmentsChecked(childrenViewList.dealershipId)) {
      if (!temp[childrenViewList.dealershipId?.id]) {
        temp[childrenViewList.dealershipId.id] = {};
      }

      childrenViewList.dealershipId?.departments?.forEach((department) => {
        if (!department.disabled) {
          // Filter out disabled roles before adding their IDs to temp
          const enabledRoleIds = department.roles.filter((role) => !role.disabled).map((role) => role.id);
          temp[childrenViewList.dealershipId?.id][department.id] = enabledRoleIds;
        }
      });
    } else {
      childrenViewList.dealershipId?.departments.forEach((department) => {
        delete temp[childrenViewList.dealershipId?.id][department.id];
      });

      if (Object.keys(temp[childrenViewList.dealershipId?.id]).length === 0) {
        delete temp[childrenViewList.dealershipId?.id];
      }
    }
    setSelectedList(temp);
  };

  const onSelectAllRoles = () => {
    const temp = { ...selectedList };
    const dealer = childrenViewList.dealershipId;
    const department = childrenViewList.departmentId;

    if (dealer && department) {
      if (!temp[dealer.id]) {
        temp[dealer.id] = {};
      }

      if (!temp[dealer.id][department.id] || !isAllRolesChecked(dealer, department)) {
        // Filter out disabled roles before adding their IDs to temp
        const enabledRoleIds = department.roles.filter((role) => !role.disabled).map((role) => role.id);
        temp[dealer.id][department.id] = enabledRoleIds;
      } else {
        delete temp[dealer.id][department.id];
      }

      if (Object.keys(temp[dealer.id]).length === 0) {
        delete temp[dealer.id];
      }
      setSelectedList(temp);
    }
  };

  // Helper functions
  const isAllDealershipsChecked = () =>
    filteredDealerships.every((dealer) => {
      if (dealer.disabled) {
        return true; // Disabled dealers are considered as checked
      }

      const allDepartmentsCheckedOrDisabled = dealer.departments.every((department) => {
        const departmentCheckedRoles = selectedList[dealer.id]?.[department.id];
        const enabledRolesCount = department.roles.filter((role) => !role.disabled).length;

        return departmentCheckedRoles?.length === enabledRolesCount || department.disabled;
      });

      return allDepartmentsCheckedOrDisabled;
    });

  const isAllDepartmentsChecked = (dealer) => {
    if (dealer && selectedList[dealer.id]) {
      const totalDepartments = dealer.departments.length;
      const checkedOrDisabledDepartments = dealer.departments.filter((department) => {
        const departmentCheckedRoles = selectedList[dealer.id][department.id];
        const enabledRolesCount = department.roles.filter((role) => !role.disabled).length;
        return departmentCheckedRoles?.length === enabledRolesCount || department.disabled;
      }).length;

      return totalDepartments === checkedOrDisabledDepartments;
    }
    return false;
  };

  const isAllRolesChecked = (dealer, department) => {
    if (department && department.roles && selectedList[dealer.id] && selectedList[dealer.id][department.id]) {
      const departmentCheckedRoles = selectedList[dealer.id][department.id];
      const enabledRolesCount = department.roles.filter((role) => !role.disabled).length;

      return departmentCheckedRoles.length === enabledRolesCount;
    }
    return false;
  };

  const getColor = (isChecked, isIndeterminate, disabled) => {
    if (disabled) return '#D0D5DD';
    return isChecked || isIndeterminate ? '#5925DC' : '#10182B';
  };

  const dealerChildrenView = (dealer, disabled, errMsg) => {
    if (disabled) {
      ErrorToast(errMsg);
      return;
    }
    setChildrenViewList({
      dealershipId: dealer,
    });
  };

  const departmentChildrenView = (department, disabled, errMsg) => {
    if (disabled) {
      ErrorToast(errMsg);
      return;
    }
    setChildrenViewList((app) => ({
      ...app,
      departmentId: department,
    }));
  };

  const checkIndeterminate = (checked, total) => {
    if (checked >= 1 && checked < total) {
      return true;
    }
    return false;
  };

  const getCheckedDeparts = (dealer) => {
    let totalCheckedDepartments = 0;
    const totalDepartments = dealer.departments.length;

    dealer.departments.forEach((department) => {
      const checkedRoles = selectedList[dealer.id]?.[department.id] || [];
      if (checkedRoles.length > 0) {
        totalCheckedDepartments += 1;
      }
    });

    return { totalCheckedDepartments, totalDepartments };
  };

  const getCheckedRoles = (department) => {
    const roleIds = department.roles.map((role) => role.id);
    let totalCheckedRoles = 0;
    let totalRoles = 0;

    if (selectedList[childrenViewList.dealershipId.id]?.[department.id]) {
      totalCheckedRoles = roleIds.filter((roleId) =>
        selectedList[childrenViewList.dealershipId.id][department.id].includes(roleId),
      ).length;
    }

    totalRoles = roleIds.length;

    return { totalCheckedRoles, totalRoles };
  };

  // Move selected dealership on the top
  const sortedDealerships = useMemo(() => {
    const selectedDealershipIds = Object.keys(selectedList);
    return filteredDealerships.slice().sort((a, b) => {
      const shouldMoveUpA = selectedDealershipIds.includes(a.id.toString());
      const shouldMoveUpB = selectedDealershipIds.includes(b.id.toString());
      if (shouldMoveUpA && !shouldMoveUpB) {
        return -1;
      }
      if (!shouldMoveUpA && shouldMoveUpB) {
        return 1;
      }
      return 0;
    });
  }, [filteredDealerships, selectedList]);

  const selectDealerships = (
    <Grid container direction="row">
      <Grid item xs={12}>
        {sortedDealerships?.map((dealer) => {
          const { totalCheckedDepartments, totalDepartments } = getCheckedDeparts(dealer);
          const isChecked = totalCheckedDepartments === totalDepartments;
          const isIndeterminate = checkIndeterminate(totalCheckedDepartments, totalDepartments);
          return (
            <Grid
              container
              key={dealer.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: childrenViewList.dealershipId?.id === dealer.id ? '#F4F3FF' : 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    color: isChecked || isIndeterminate ? '#5925DC' : '#D0D5DD',
                    borderRadius: '8px',
                  }}
                  checked={isChecked}
                  onChange={(event) => {
                    dealerChildrenView(dealer, dealer.disabled, dealer.error);
                    onChangeDealer(dealer, event.target.checked, isIndeterminate);
                  }}
                  disabled={dealer.disabled}
                  indeterminate={isIndeterminate}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  noWrap
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, isIndeterminate, dealer.disabled),
                  }}
                  onClick={() => dealerChildrenView(dealer, dealer.disabled, dealer.error)}
                >
                  <span>{dealer.name} </span>
                  {totalCheckedDepartments > 0 ? (
                    <span className={classes.countBox}>
                      {totalCheckedDepartments} / {totalDepartments}
                    </span>
                  ) : null}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <ChevronRight
                  style={{ cursor: 'pointer', color: getColor(isChecked, isIndeterminate, dealer.disabled) }}
                  onClick={() => dealerChildrenView(dealer, dealer.disabled, dealer.error)}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  const selectDepartments = (
    <Grid container direction="row">
      <Grid item className={classes.scrollableGrid} xs={12}>
        {childrenViewList.dealershipId?.departments?.map((department) => {
          const { totalCheckedRoles, totalRoles } = getCheckedRoles(department);
          const isChecked = totalCheckedRoles === totalRoles;
          const isIndeterminate = checkIndeterminate(totalCheckedRoles, totalRoles);
          return (
            <Grid
              container
              key={department.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: childrenViewList.departmentId?.id === department.id ? '#F4F3FF' : 'white',
                borderRadius: '4px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    borderRadius: '8px',
                    color: isChecked || isIndeterminate ? '#5925DC' : '#D0D5DD',
                  }}
                  checked={isChecked}
                  onChange={(event) => {
                    departmentChildrenView(department, department.disabled, department.error);
                    onChangeDepartment(department, event.target.checked, isIndeterminate);
                  }}
                  disabled={department.disabled}
                  indeterminate={isIndeterminate}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  noWrap
                  className={classes.filedName}
                  style={{
                    color: getColor(isChecked, isIndeterminate, department.disabled),
                  }}
                  onClick={() => departmentChildrenView(department, department.disabled, department.error)}
                >
                  <span>{department.name} </span>
                  {totalCheckedRoles > 0 ? (
                    <span className={classes.countBox}>
                      {totalCheckedRoles} / {totalRoles}
                    </span>
                  ) : null}
                </Typography>
              </Grid>
              <Grid item xs={2}>
                <ChevronRight
                  style={{ cursor: 'pointer', color: getColor(isChecked, isIndeterminate, department.disabled) }}
                  onClick={() => departmentChildrenView(department, department.disabled, department.error)}
                />
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  const selectRoles = (
    <Grid container direction="row">
      <Grid item className={classes.scrollableGrid} xs={12}>
        {childrenViewList.departmentId?.roles?.map((role) => {
          const isChecked = checkRole(role);
          return (
            <Grid
              container
              key={role.id}
              alignContent="center"
              alignItems="center"
              style={{
                backgroundColor: 'white',
                borderRadius: '8px',
              }}
            >
              <Grid item xs={2}>
                <Checkbox
                  name="checkedBox"
                  color="primary"
                  style={{
                    borderRadius: '8px',
                    color: isChecked ? '#5925DC' : '#D0D5DD',
                  }}
                  checked={isChecked}
                  onChange={(event) => onChangeRole(role, event.target.checked)}
                  disabled={role.disabled}
                />
              </Grid>
              <Grid item xs={8}>
                <Typography
                  noWrap
                  style={{
                    fontWeight: '600',
                    fontSize: '14px',
                    cursor: 'pointer',
                    color: getColor(isChecked, false, role.disabled),
                  }}
                  onClick={() => role.disabled && ErrorToast(role.error)}
                >
                  {role.name}
                </Typography>
              </Grid>
            </Grid>
          );
        })}
      </Grid>
    </Grid>
  );

  return (
    <div className={classes.mainDivForStep2}>
      <div className={classes.searchDealershipContainer}>
        <TextField
          id="searchDealershipId"
          name="searchDealership"
          required
          autoComplete="off"
          autoSave="off"
          placeholder="Search Dealerships"
          style={{ width: '33%' }}
          onChange={handleDealershipSearch}
          value={searchDealershipValue}
          InputProps={{
            disableUnderline: true,
            className: classes.searchText,
          }}
          rows={1}
        />
      </div>

      <Grid container>
        {sortedDealerships?.length >= 1 ? (
          <Grid item xs={4} style={{ height: '35vh' }}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              style={{ background: 'lightGrey', width: '100%', marginLeft: '0px' }}
              onChange={onSelectAllDealerships}
              checked={isAllDealershipsChecked()}
            />
            <Grid
              className={classes.gridContainerStyle}
              style={{ overflowX: 'hidden', overflowY: 'auto', height: '85%' }}
            >
              {selectDealerships}
            </Grid>
          </Grid>
        ) : (
          <Grid item xs={4} style={{ height: '35vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <ZeroState Icon={CarIcon} text="No dealerships found for the applied filters." cardWidth="80%" />
          </Grid>
        )}

        {childrenViewList.dealershipId?.id ? (
          <Grid item xs={4} style={{ height: '35vh', borderLeft: '2px solid #D9D6FE' }}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.checkBoxWrapper}
              onChange={onSelectAllDepartments}
              checked={isAllDepartmentsChecked(childrenViewList.dealershipId)}
            />
            <Grid className={classes.gridContainerStyle}>{selectDepartments}</Grid>
          </Grid>
        ) : (
          <Grid item xs={4} className={classes.centerBoxElement}>
            Select dealership first
          </Grid>
        )}

        {childrenViewList.dealershipId?.id && childrenViewList.departmentId?.id ? (
          <Grid item xs={4} style={{ height: '35vh', borderLeft: '2px solid #D9D6FE' }}>
            <FormControlLabel
              control={<Checkbox color="white" className={classes.selectAllCheckbox} />}
              label="Select all"
              className={classes.checkBoxWrapper}
              onChange={onSelectAllRoles}
              checked={isAllRolesChecked(childrenViewList.dealershipId, childrenViewList.departmentId)}
            />
            <Grid className={classes.gridContainerStyle}>{selectRoles}</Grid>
          </Grid>
        ) : (
          <Grid item xs={4} className={classes.centerBoxElement}>
            Select department first
          </Grid>
        )}
      </Grid>
    </div>
  );
}
